export default "__VITE_ASSET__Dmj2M3iW__"